<script lang="ts">
  import type ServiceProvider from "../services/service.provider";
  import type DataProvider from "../services/data.provider";
  import type { Type } from "../interfaces/search.interface";

  export let serviceProvider: ServiceProvider;
  export let dataProvider: DataProvider;

  let typeOptions = dataProvider.types;

  const getValueOfSelectedChild = (children: Type[], selectedType: string) => {
    const selectedChild = children.find((child) => child.id === selectedType);
    return selectedChild ? selectedChild.value : children[0].value;
  };

  const isSelectedOneOfChildren = (children: Type[], selectedType: string) => {
    const selectedChild = children.find((child) => child.id === selectedType);
    return !!selectedChild;
  };

  const toggleSubmenu = (typeOption: Type): void => {
    typeOption.opened = !typeOption.opened;
    typeOptions = typeOptions;
  };

  const onSelectedType = (selectedTypeId: string): void => {
    dataProvider.type = selectedTypeId || "";
    serviceProvider.searchService.submitTypeChange();

    closeAll();
  };

  const closeAll = () => {
    typeOptions = typeOptions.map((typeOption) => {
      if ("children" in typeOption) {
        return { ...typeOption, opened: false };
      }
      return { ...typeOption };
    });
  };

  // close submenu, if click outside
  window.onclick = (e: any) => {
    if (
      !e.target.closest(".js-display-submenu") &&
      !e.target.closest(".js-submenu")
    ) {
      closeAll();
    }
  };
</script>

<div class="bno-tab-links">
  <ul
    class="bno-list--plain bno-tab-links__holder"
    role="menubar"
    aria-label="Upřesnění vyhledávání"
  >
    {#each typeOptions as typeOption}
      <li class="bno-tab-links__item" role="menuitem">
        {#if typeOption.children && typeOption.children.length}
          <button
            class="bno-button bno-button--link js-display-submenu {typeOption.opened
              ? 'opened'
              : ''} {isSelectedOneOfChildren(
              typeOption.children,
              dataProvider.type
            )
              ? 'selected'
              : ''}"
            aria-expanded={typeOption.opened ? "true" : "false"}
            aria-haspopup="menu"
            aria-controls="vsechny-dokumenty"
            aria-label="Výběr typu dokumentu"
            on:click={() => toggleSubmenu(typeOption)}
          >
            <span>{getValueOfSelectedChild(typeOption.children, dataProvider.type)}</span>
            <span class="bno-icon bno-icon--arrow-narrow" aria-hidden="true" />
          </button>
          <div
            class="bno-tab-links__subholder js-submenu {typeOption.opened
              ? 'u-show'
              : 'u-hide'}"
          >
            <ul
              class="bno-list--plain"
              role="menu"
              tabindex="-1"
              id="vsechny-dokumenty"
              aria-label="Výběr typu dokumentu"
            >
              {#each typeOption.children as typeSubOption}
                <li class="bno-tab-links__subitem">
                  {#if typeSubOption.id === dataProvider.type}
                    <span>{typeSubOption.value}</span>
                  {:else}
                    <button
                      class="bno-tab-links__subitem-link"
                      type="button"
                      aria-controls={typeSubOption.id}
                      aria-label={typeSubOption.value}
                      on:click={() => onSelectedType(typeSubOption.id)}
                    >
                      {typeSubOption.value}
                    </button>
                  {/if}
                </li>
              {/each}
            </ul>
          </div>
        {:else if typeOption.id === dataProvider.type}
          <span>{typeOption.value}</span>
        {:else}
          <button
            class="bno-button bno-button--link"
            type="button"
            aria-expanded="false"
            aria-haspopup="menu"
            aria-controls={typeOption.id}
            aria-label={typeOption.value}
            on:click={() => onSelectedType(typeOption.id)}
          >
            <span>{typeOption.value}</span>
          </button>
        {/if}
      </li>
    {/each}
  </ul>
</div>
